/**
 * USER LIBRARY PAGE
 */
export const userLibraryPageActionTypes = {
  FETCH_USER_LIBRARY_PAGE_DATA_START: "FETCH_USER_LIBRARY_PAGE_DATA_START",
  FETCH_USER_LIBRARY_PAGE_DATA_SUCCESS: "FETCH_USER_LIBRARY_PAGE_DATA_SUCCESS",
  FETCH_USER_LIBRARY_PAGE_DATA_ERROR: "FETCH_USER_LIBRARY_PAGE_DATA_ERROR",
  SET_MY_PLAYLISTS: "SET_MY_PLAYLISTS",
  SET_MY_SAVED_ALBUMS: "SET_MY_SAVED_ALBUMS",
};
